// extracted by mini-css-extract-plugin
export default {"wrap":"EventMedia_wrap__b+YnW","image":"EventMedia_image__ulPGr","audio":"EventMedia_audio__hXb5b","video":"EventMedia_video__16MQ8"};